import { Component, OnInit, ViewChild } from '@angular/core';
import { DisplayService } from './service/display.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [DisplayService]
})
export class AppComponent implements OnInit {
  title = 'app works!';

  // 画面ID
  readonly SCREEN_ID = 'O90';
  /** リンク */
  public dispO9001: string;
  /** 画面カスタマイズ情報 */
  public dispZ0000: string;
  /** 現在年 */
  public nowYear: number;
  /** 共通画面資材URL */
  public assetsPortalBaseUrl: string;
  /** よくあるご質問URL */
  public faqUrl: string;
  /** お問い合わせの前にURL */
  public beforeRequestUrl: string;
  /** AduMEとはURL */
  public aboutAdumeUrl: string;
  /** 利用規約URL*/
  public termsOfServiceUrl: string;
  /** 個人情報の取り扱いについてURL */
  public privacyUrl: string;

  @ViewChild('footerModal', { static: false }) footerModal: ModalDirective;
  @ViewChild('footerModal2', { static: false }) footerModal2: ModalDirective;

  constructor(private displayService: DisplayService, private translateService: TranslateService) {
    this.translateService.setDefaultLang('ja');
    this.translateService.use('ja');
  }

  async ngOnInit() {
    this.nowYear = new Date().getFullYear();
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
  }

  async getDisplayInfo() {
    const data = await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).toPromise();
    this.dispO9001 = '';
    this.dispZ0000 = '';
    if (data.displayInfo != null) {
      if (data.displayInfo.O9001 != null) {
        this.dispO9001 = data.displayInfo.O9001;
      }
      if (data.displayInfo.Z0000 != null) {
        this.dispZ0000 = data.displayInfo.Z0000;
      }
    }
    if (data.language === 'en') {
      this.translateService.setDefaultLang('en');
      this.translateService.use('en');
    }

    this.translateService.get('FAQ_URL').subscribe((res: string) => {
      this.faqUrl = this.assetsPortalBaseUrl + res;
    });
    this.translateService.get('BEFORE_REQUEST_URL').subscribe((res: string) => {
      this.beforeRequestUrl = this.assetsPortalBaseUrl + res;
    });
    this.translateService.get('ABOUT_ADUME_URL').subscribe((res: string) => {
      this.aboutAdumeUrl = this.assetsPortalBaseUrl + res;
    });
    this.translateService.get('TERMS_OF_SERVICE_URL').subscribe((res: string) => {
      this.termsOfServiceUrl = this.assetsPortalBaseUrl + res;
    });
    this.translateService.get('PRIVACY_URL').subscribe((res: string) => {
      this.privacyUrl = this.assetsPortalBaseUrl + res;
    });
  }

  /**
   * about AduME押下処理
   */
  aboutOpen() {
    this.footerModal.show();
  }

  aboutClose() {
    this.footerModal.hide();
  }
}


